import type { AssetRegistry } from "../assets/AssetRegistry";
import { type EarlyBrandingResult, preloadOperatorLoaderBranding } from "../branding/OperatorLoaderBranding";
import { wallClockSleep } from "./utils/wallClockSleep";
import type { Log } from "@slot/presentation";

/**
 * The operator's loader art, when its id is known before any backend call (the query or the config override):
 * the manifest and loader bundle raced against a timeout, so the loader paints with the operator's
 * art when it arrives in time and with the default art otherwise. Null: no operator, or too late.
 */
export async function resolveEarlyBranding(input: { assets: AssetRegistry; operatorId: string | null; manifestBaseUrl: string; gameVersion: string | undefined; timeoutMs: number; log: Log }): Promise<EarlyBrandingResult | null> {
  if (!input.operatorId) return null;
  let settled = false;
  const branding = preloadOperatorLoaderBranding({ assets: input.assets, operatorId: input.operatorId, manifestBaseUrl: input.manifestBaseUrl, gameVersion: input.gameVersion, log: input.log }).then((result) => {
    settled = true;
    return result;
  });
  const timeout = wallClockSleep(input.timeoutMs).then((): EarlyBrandingResult | null => {
    if (!settled) input.log(`[EarlyBranding] timed out after ${input.timeoutMs}ms — showing default loader`);
    return null;
  });
  return Promise.race([branding, timeout]);
}
